import { Model } from "../model";
import { VariableValue } from "./variable-value";

export class VariableOption implements Model {
    _id: string;
    label: string;
    variableValue: VariableValue;
}